import ApiModel          from '@widesk-core/models/ApiModel';
import MonolithConnector from '@/models/MonolithConnector.ts';
import config            from '@/config';

export const rhConnector = new MonolithConnector({
	baseURL: config.api_endpoint + `/monolith/rh`,
});

export default class RHServiceModel extends ApiModel {
	public static get connector() {
		return rhConnector;
	}

	public static serviceName = 'rh';
	public static partitionName = 'jts';
}
